/*
  NAVEE 定制：产品页信任标识选项卡的切换。
  事件委托挂在 document 上，所以主题编辑器里重新渲染 section 也不用重新初始化。
  选中态由 .is-active（标签）和 hidden（面板）控制，样式全在 trust-badges.css 里。
*/
(function () {
  function tabsOf(group) {
    return Array.prototype.slice.call(group.querySelectorAll('.trust-badges__tab'));
  }

  function activate(group, tab) {
    var tabs = tabsOf(group);

    tabs.forEach(function (item) {
      var selected = item === tab;
      var panel = document.getElementById(item.getAttribute('aria-controls'));

      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      // 只有选中的标签留在 Tab 键序列里，方向键在标签之间移动。
      item.setAttribute('tabindex', selected ? '0' : '-1');
      if (panel) panel.hidden = !selected;
    });

    // 下划线的滑动全部交给 CSS transition，这里只更新它停在第几列。
    group.style.setProperty('--tb-active-index', tabs.indexOf(tab));
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.trust-badges__tab');
    if (!tab) return;

    var group = tab.closest('.trust-badges');
    if (!group) return;

    activate(group, tab);
  });

  document.addEventListener('keydown', function (event) {
    var step = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' }[event.key];
    if (!step) return;

    var tab = event.target.closest('.trust-badges__tab');
    if (!tab) return;

    var group = tab.closest('.trust-badges');
    if (!group) return;

    var tabs = tabsOf(group);
    var next;

    if (step === 'first') {
      next = tabs[0];
    } else if (step === 'last') {
      next = tabs[tabs.length - 1];
    } else {
      next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];
    }

    event.preventDefault();
    activate(group, next);
    next.focus();
  });
})();
